/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  ADD_ACCOUNT,
  GET_ACCOUNTS_SUCCESS,
  GET_ACCOUNTS_FAILURE,
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAILURE,
  REMOVE_ACCOUNT,
  REMOVE_ACCOUNT_SUCCESS,
  REMOVE_ACCOUNT_FAILURE,
  UNLINK_ASSETS,
  UNLINK_ASSETS_SUCCESS,
  UNLINK_ASSETS_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  accounts: [],
  accountsLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_ACCOUNT:
      return {
        ...state,
        accountsLoading: true,
      };
    case ADD_ACCOUNT_SUCCESS:
      return {
        ...state,
        accounts: [...state.accounts, action.payload.data],
        accountsLoading: false,
      };
    case ADD_ACCOUNT_FAILURE:
      return {
        ...state,
        accountsLoading: false,
      };
    // case GET_ACCOUNTS:
    //     return {
    //         accounts: action.payload.data,
    //         getAccountsSuccess: true

    //     };
    case GET_ACCOUNTS_SUCCESS:
      return {
        // ...state,
        accounts: action.payload.data,
        getAccountsSuccess: true,
      };
    case GET_ACCOUNTS_FAILURE:
      return {
        // ...state,
        accounts: state.accounts,
        getAccountsSuccess: false,
      };
    case REMOVE_ACCOUNT:
      return {
        accounts: state.accounts,
        removingAccount: true,
      };
    case REMOVE_ACCOUNT_SUCCESS:
      return {
        ...state,
        accounts: state.accounts.filter(
          (account) => account._id !== action.payload._id
        ),
        removingAccount: false,
        isRemovingSuccess: true,
      };
    case REMOVE_ACCOUNT_FAILURE:
      return {
        ...state,
        removingAccount: false,
        isRemovingSuccess: false,
      };

    case UNLINK_ASSETS:
      return {
        accounts: state.accounts,
        unlinkingAssets: true,
        isUnlinkingSuccess: false,
      };
    case UNLINK_ASSETS_SUCCESS:
      const assets = action.payload.assets;
      const accountId = action.payload.accountId;
      const index = state.accounts.findIndex(
        (account) => account._id === accountId
      );
      const newassets = state.accounts[index].assetsLinked.filter(
        (assetLinked) => {
          return !assets.some((assetId) => assetId === assetLinked._id);
        }
      );
      state.accounts[index].assetsLinked = newassets;

      return {
        accounts: state.accounts,
        unlinkingAssets: false,
        isUnlinkingSuccess: true,
      };
    case UNLINK_ASSETS_FAILURE:
      return {
        accounts: state.accounts,
        unlinkingAssets: false,
        isUnlinkingSuccess: false,
      };
    default:
      return state;
  }
}
